import Grid from "@components/Grid/Grid";
import RenderComponents from "@utilities/renderComponents";
import Components from "../../__Components__/Components";

export type PageProps = {
  headerBanner?: any;
  bodyContent?: any;
};

export const EELandingPage = (props: { content: PageProps }) => {
  const { content } = props;
  const { bodyContent, headerBanner } = content;

  return (
    <Grid row>
      <Grid column sm={12}>
        {headerBanner &&
          Components(
            {
              component: headerBanner.component,
              uid: headerBanner.uid,
              ...headerBanner.fields,
            },
            headerBanner.fields
          )}

        {RenderComponents(bodyContent)}
      </Grid>
    </Grid>
  );
};

export default EELandingPage;
